import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uid: null,
}

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    logout() {
      return initialState;
    },
    login(state, action) {
      state.uid = action.payload.uid;
    },
  }
});

export const userActions = userSlice.actions;

export default userSlice.reducer;